import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AnonymousNotificationPreferencesDto, UpdateAnonymousNotificationPreferencesCommand} from "homey-housing-lottery-app-dto";
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AnonymousNotificationPreferencesService {
  private readonly http = inject(HttpClient);

  getPreferences(anonymousId: string) {
    return this.http.get<AnonymousNotificationPreferencesDto>(`${environment.apiUrl}/api/public/notification-settings/preferences`, {params: {id: anonymousId}});
  }

  updatePreference(command: UpdateAnonymousNotificationPreferencesCommand) {
    return this.http.put<AnonymousNotificationPreferencesDto>(`${environment.apiUrl}/api/public/notification-settings/preferences`, command);
  }
}
